/**
 * JitaContextBadge — pill que muestra "+12.3% 30d" / "-8.1% 30d" / "0.0% 30d"
 * comparando el current price de un item contra su avg de las últimas 30d en
 * Jita. Usado por Refinery (vender ore) y Utility (sell-advice) para dar
 * contexto de tendencia en cada precio.
 *
 * Caveat: ESI market history = sell-order avg. Direction del trend OK; ISK
 * exacto puede mentir ~3-10% (en realidad cobrarías buy orders).
 *
 * Se renderiza NULL cuando no hay datos (load, sin history, sin current price)
 * para no distraer — el precio sin badge sigue siendo la info primaria.
 */

import { formatISK } from '../api'

export function JitaContextBadge({
  delta,
  avg,
  current,
}: {
  delta: number | null
  avg: number | null
  current: number | null
}) {
  if (delta === null) return null

  const neutral = Math.abs(delta) < 0.5
  const positive = delta > 0
  const classes = neutral
    ? 'bg-eve-muted/10 border-eve-border text-eve-muted'
    : positive
      ? 'bg-eve-success/10 border-eve-success text-eve-success'
      : 'bg-eve-danger/10 border-eve-danger text-eve-danger'

  const title =
    avg !== null && current !== null
      ? `Jita hoy ${formatISK(current, 2)} vs avg 30d ${formatISK(avg, 2)} (sell-order avg)`
      : 'Comparación vs avg 30d en Jita'

  return (
    <span
      className={`text-[10px] font-mono px-1.5 py-0.5 rounded border whitespace-nowrap ${classes}`}
      title={title}
    >
      {delta >= 0 ? '+' : ''}
      {delta.toFixed(1)}% <span className="opacity-70">30d</span>
    </span>
  )
}